module.exports = __webpack_public_path__ + "static/4-e5ccb84d2b5700f9e29abf659daf96d5.jpg";